export default __webpack_public_path__ + "static/media/patio_logo.64d9a405.svg";